// Copyright (C) 2023 Cochise Ruhulessin
// 
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import axios, { AxiosInstance } from 'axios'


interface DeviceBattery {
  percentage: number
}


interface DeviceGrade {
  grade: string
}


interface Device {
  battery: DeviceBattery
  id: number
  imei: string[]
  manufacturer: string
  name: string
  grading: DeviceGrade
}


class DeviceService {
  http: AxiosInstance

  constructor() {
    this.http = axios.create({
      baseURL: "/api/devices",
      withCredentials: true
    })
  }

  async get(documentRef: string): Promise<Device | null> {
    try {
      const response = await this.http.get(`/${documentRef}`)
      return response.data
    } catch (e: any) {
      if (!e.isAxiosError || e.response.status !== 404) { throw e}
      return null
    }
  }
}


export {
  DeviceService
}

export type { Device }